import { InfoBar } from '@design-system/info-bar';
import React, { FC } from 'react';

import { TopBarProps } from './models';

const TopBar: FC<TopBarProps> = ({
  className,
  messages,
  ariaLabels,
  soloMode,
  intervalTime,
  showInfoBar,
}) =>
  showInfoBar ? (
    <InfoBar
      soloMode={soloMode}
      className={className}
      intervalTime={intervalTime}
      messages={messages}
      ariaLabels={{
        play: ariaLabels?.playButtonAriaLabel!,
        pause: ariaLabels?.pauseButtonAriaLabel!,
        arrowRight: ariaLabels?.nextButtonAriaLabel!,
        arrowLeft: ariaLabels?.previousButtonAriaLabel!,
      }}
    />
  ) : null;

export default TopBar;
